import axios from "axios";
import Constants from "../../constants/Constants";

const namespaced = true;

const apiState = Constants.APPLICATION.API_STATE;

const state = Constants.GITHUB;
state.apiState = Constants.APPLICATION.API_STATE.INIT;

const getters = {
  github(state) {
    return state;
  },
  apiState(state) {
    return state.apiState;
  },
  githubProjects(state) {
    return state.projects;
  },
};

const mutations = {
  setApiState(state, payload) {
    state.apiState = payload;
  },
  setGithubProjects(state, payload) {
    state.projects = payload;
  },
};

const actions = {
  loadGithubProjects({ commit }) {
    commit("setApiState", apiState.LOADING);
    const githubProjects = this.state.github.repos;

    console.log("Github Projects", githubProjects);
    const arr = [];
    for (let i = 0; i < githubProjects.length; i++) {
      const repo = {
        name: "",
        description: "",
        commits: [],
      };
      const e = githubProjects[i];
      axios
        .get(this.state.github.GET_API_REPO_URL(e))
        .then((res) => {
          repo.name = res.data.name;
          repo.description = res.data.description;
        })
        .catch((err) => {
          console.log("Error:", err);
        });

      axios
        .get(this.state.github.GET_API_COMMITS_URL(e))
        .then((res) => {
          return res.data;
        })
        .then((commits) => {
          let amount = commits.length;
          for (let index = 0; index < commits.length; index++) {
            amount -= 1;
            const commit = commits[index].commit;

            const c = {
              date: commit.author.date,
              name: "Author: " + commit.author.name,
              comment: "Comment: " + commit.message,
              value: amount,
            };

            repo.commits.push(c);
          }
        })
        .catch((err) => {
          console.log("Error:", err);
        });
      arr.push(repo);
    }
    console.log("Github projects", arr);
    commit("setGithubProjects", arr);
    commit("setApiState", apiState.LOADED);
  },
};

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions,
};
